module.exports = __webpack_public_path__ + "img/SL-M-180-230.1d09149c.svg";